import getAny from 'utils/accessors/getAny.util';
import fromAnyToString from 'utils/converters/fromAnyToString';

const getString = (path, root) => fromAnyToString(getAny('', path, root));

// noinspection JSUnusedGlobalSymbols
export default getString;
